






























import Vue from 'vue'
import { Tab } from '@/types/tabs'
import './TabDisplay.scss'

export default Vue.extend({
  name: 'TabDisplay',
  props: {
    tabs: {
      type: Array as () => Tab[],
      required: true
    },
    externalUpdate: {
      type: Number,
      required: false
    },
    remoteValue: {
      type: Boolean,
      default: false
    },
    breakout:  {
      type: Boolean,
      required: false,
      default: false
    },
    isCastView:  {
      type: Boolean,
      required: false,
      default: false
    }
  },
  watch: {
    externalUpdate (newVal: number): void {
      if (newVal !== this.selectedTab) {
        this.setTab(newVal)
        this.selectedTab = newVal
      }
    }
  },
  data: () => ({
    selectedTab: 0
  }),
  created (): void {
    this.selectedTab = this.remoteValue && this.externalUpdate !== 0 ? this.externalUpdate : 0
  },
  methods: {
    setTab (tab: number): void {
      if (!this.remoteValue) this.selectedTab = tab
      this.$emit('changed', this.tabs[tab].value)
    },
    breakoutTabs (): void {
        this.$store.direct.dispatch.events.openActionPaletteInNewWindow()
    },
  }
})
